const isProd = process.env.NODE_ENV === "production";

const LOCAL_URL = "http://localhost/Zenite.Ria.Web.Resultados.Curitiba/api";
const SERVER_URL = isProd ? document.getElementById("urlApi").value : LOCAL_URL;
const CONSULTORIO_URL = isProd ? "/consultorios" : "http://localhost/consultorios";

const CONTATO = "(34) 3820-1650"; //  comunicacao@dominio.com.br
const PATH_LOGO = require("../img/logo.png");

const IMAGES_BANNER = [
    "https://www.lamel.com.br/fotos/2128065012-banners-site-julho-1.jpg",
    "https://www.lamel.com.br/fotos/1459455023-banners-site-julho-3.jpg",
    "https://www.lamel.com.br/fotos/855953612-banners-site-junho-4.jpg",
];

const DEFAULT_PACIENTE = { chave: "", date: "" };
const DEFAULT_MEDICO = { codigo: "", senha: "" };
const DEFAULT_MEDICO_COLABORADOR = { codigo: "", senha: "" };
const DEFAULT_CONVENIO = { codigo: "", senha: "" };
const DEFAULT_PROCEDENCIA = { codigo: "", senha: "" };
const DEFAULT_PACIENTE_TOKEN = { token: "", documento: "" };
const RECAPTCHA_SITE_KEY = "6Lc9T_UZAAAAAMmHuTjV-NHw_BhrdROSKxBDZCWX";

export default {
    SERVER_URL,
    CONTATO,
    PATH_LOGO,
    IMAGES_BANNER,
    DEFAULT_PACIENTE,
    DEFAULT_MEDICO,
    DEFAULT_MEDICO_COLABORADOR,
    DEFAULT_CONVENIO,
    DEFAULT_PROCEDENCIA,
    DEFAULT_PACIENTE_TOKEN,
    RECAPTCHA_SITE_KEY,
    CONSULTORIO_URL,
};
